import { createFileRoute } from '@tanstack/react-router'
import { SecuritySettings } from '@/features/settings/ui/security-settings'

export const Route = createFileRoute('/_authenticated/account/security')({
	component: SecurityPage,
})

function SecurityPage() {
	return <SecuritySettings />
}
